import { create } from "zustand";
import type { PartsTable } from "../models/Partslist";
import { fetchPartsPrice, updatePartsPrice } from "../../src/apiServices/partsPricingApi";
import { useUserStore } from "./userStore";

type ApiResponse<T> = { statusCode: number; message?: string; data?: T };

interface PartsState {
  parts: PartsTable[];
  fetchParts: () => Promise<void>;
  updateParts: (updatedRows: PartsTable | PartsTable[]) => Promise<ApiResponse<any>>;
}

function resolveOem(): string {
  const s: any = useUserStore.getState();
  const legacy = s.currentOEM?.oemName as string | undefined;
  if (legacy && legacy.trim()) return legacy;
  const u = s.user as { oemId?: number } | null;
  if (u?.oemId) return `Oem${u.oemId}`;
  const envDefault = (import.meta as any)?.env?.VITE_DEFAULT_OEM as string | undefined;
  return envDefault && envDefault.trim() ? envDefault : "Oem1";
}

export const usePartsStore = create<PartsState>((set, get) => ({
  parts: [],

  fetchParts: async () => {
    try {
      const oem = resolveOem();
      const result = await fetchPartsPrice(oem);
      set({ parts: result });
    } catch (error) {
      console.error("Error fetching parts:", error);
      set({ parts: [] });
    }
  },

  updateParts: async (updatedRows: PartsTable | PartsTable[]) => {
    try {
      const oem = resolveOem();
      const rowsArray = Array.isArray(updatedRows) ? updatedRows : [updatedRows];

      const response = await updatePartsPrice(oem, rowsArray);

      const currentParts = get().parts;
      const newParts = currentParts.map((p) => {
        const updated = rowsArray.find((u) => u.partId === p.partId);
        return updated ? { ...p, ...updated } : p;
      });

      set({ parts: newParts });

      return response; // ✅ now type matches
    } catch (error) {
      console.error("Error updating parts:", error);
      throw error;
    }
  },
}));
